<script>
  import { Line, mixins } from 'vue-chartjs';
  import { kFormatter } from '../../../utils/Math_util';

  const { reactiveProp } = mixins;

  export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
    mounted() {
      this.renderChart(this.chartData, {
        elements: {
          point: {
            radius: 2
          }
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,

          custom: function (tooltipModel) {
            let tooltipEl = document.getElementById('chartjs-tooltip');

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            // Set Text
            if (tooltipModel.body) {
              let bodyLines = tooltipModel.body.map(getBody);

              let innerHtml = '<thead>';

              innerHtml += '</thead><tbody>';

              bodyLines.forEach(function (body, i) {
                let colors = tooltipModel.labelColors[i];
                let style = 'background: #fff';
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 2px';
                style += '; padding: 16px';
                style += '; width: 136px';
                style += '; box-shadow: 0px 8px 29px -12px rgba(209,209,209,1);';

                style += '; border-radius: 4px';
                style += '; color:#565555';
                // style += '; font-weight:bold';
                let text = body[0].split(':');
                console.log('JJJ', text);
                let span = '<span style="' + style + '"><storong style="font-weight: bold">' + text[0]+ '</storong>:' + text[1] + '</span>';
                innerHtml += '<tr><td>' + span + '</td></tr>';
              });
              innerHtml += '</tbody>';

              let tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }
            let position = this._chart.canvas.getBoundingClientRect();
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding = 10 + 'px ' + 10 + 'px';
            tooltipEl.style.pointerEvents = 'none';
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'rgba(0, 0, 0, 0)',
              display: false,
              drawBorder: false,
            },
            ticks: {
              fontColor: '#b7b8b9'
            },

          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(0, 0, 0, 0)',
              display: false,
              drawBorder: false,
            },
            ticks: {
              fontColor: '#b7b8b9',
              callback: function (value) {
                return kFormatter(value);
              }
            }
          }]
        }
      });
    }
  };
</script>

<style>
</style>
